export class SalaryPermissionModel {
  paySalary: {
    view: boolean;
    create: boolean;
    edit: boolean;
    delete: boolean;
    approve: boolean;
  };
  summarySalary: {
    view: boolean;
    create: boolean;
    edit: boolean;
    delete: boolean;
    approve: boolean;
  };
  payment: {
    payment: boolean;
  };
  accessToPeak: {
    createDailyJournal: boolean;
  };

  constructor(isSuperUser: boolean) {
    this.paySalary = {
      view: isSuperUser,
      create: isSuperUser,
      edit: isSuperUser,
      delete: isSuperUser,
      approve: isSuperUser,
    };
    this.summarySalary = {
      view: isSuperUser,
      create: isSuperUser,
      edit: isSuperUser,
      delete: isSuperUser,
      approve: isSuperUser,
    };
    this.payment = {
      payment: isSuperUser,
    };
    this.accessToPeak = {
      createDailyJournal: isSuperUser,
    };
  }
}

export class EmployeePermissionModel {
  information: {
    view: boolean;
    create: boolean;
    edit: boolean;
    delete: boolean;
  };
  report: {
    print: boolean;
  };

  constructor(isSuperUser: boolean) {
    this.information = {
      view: isSuperUser,
      create: isSuperUser,
      edit: isSuperUser,
      delete: isSuperUser,
    };
    this.report = {
      print: isSuperUser,
    };
  }
}

export class DepartmentPermissionModel {
  information: {
    view: boolean;
    create: boolean;
    edit: boolean;
    delete: boolean;
  };
  report: {
    print: boolean;
  };

  constructor(isSuperUser: boolean) {
    this.information = {
      view: isSuperUser,
      create: isSuperUser,
      edit: isSuperUser,
      delete: isSuperUser,
    };
    this.report = {
      print: isSuperUser,
    };
  }
}

export class RevenueDeductPermissionModel {
  information: {
    view: boolean;
    create: boolean;
    edit: boolean;
    delete: boolean;
  };
  report: {
    print: boolean;
  };

  constructor(isSuperUser: boolean) {
    this.information = {
      view: isSuperUser,
      create: isSuperUser,
      edit: isSuperUser,
      delete: isSuperUser,
    };
    this.report = {
      print: isSuperUser,
    };
  }
}

export class SettingPermissionModel {
  setting: boolean;

  constructor(isSuperUser: boolean) {
    this.setting = isSuperUser;
  }
}

export class ApplicationPermissionModel {
  salary!: SalaryPermissionModel;
  employee!: EmployeePermissionModel;
  department!: DepartmentPermissionModel;
  revenueDeduct!: RevenueDeductPermissionModel;
  setting!: SettingPermissionModel;

  constructor(isSuperUser = false) {
    this.salary = new SalaryPermissionModel(isSuperUser);
    this.employee = new EmployeePermissionModel(isSuperUser);
    this.department = new DepartmentPermissionModel(isSuperUser);
    this.revenueDeduct = new RevenueDeductPermissionModel(isSuperUser);
    this.setting = new SettingPermissionModel(isSuperUser);
  }
}
